// extracted by mini-css-extract-plugin
export default {"selectAllRow":"StudentListSkeleton__selectAllRow___nZFcp","skeletonRow":"StudentListSkeleton__skeletonRow___yPtMJ","skeletonText":"StudentListSkeleton__skeletonText___iuDgt"};